import { render, staticRenderFns } from "./liveFooter.vue?vue&type=template&id=74415884&scoped=true"
import script from "./liveFooter.vue?vue&type=script&lang=js"
export * from "./liveFooter.vue?vue&type=script&lang=js"
import style0 from "./liveFooter.vue?vue&type=style&index=0&id=74415884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74415884",
  null
  
)

export default component.exports